<!-- Desktop karls Header -->
<app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>

<div class=" header-wrapper d-none d-md-block normal-header pb-md-1" [class.show]="!isSticky">
    <app-header-promotion [custom_ticker]="custom_ticker"></app-header-promotion>
    <div class="row row-xl-12 px-lg-2">
        <div class="col-md-12 col-lg-2 text-center text-lg-start logo-tabs ps-lg-4 ps-xl-5">
            <app-header-logo *ngIf="showLogo"></app-header-logo>
        </div>
        <div class="col-md-12 col-lg-10">
            <div class="row">
                <div class="col-9">
                    <div
                        class="d-flex align-items-center justify-content-center justify-content-md-start justify-content-lg-center pb-md-2">
                        <app-header-nav *ngIf="showFirstRowHeader"></app-header-nav>
                    </div>
                </div>
                <div class="col-3 d-flex align-items-center justify-content-end">
                    <app-header-contact-us-section></app-header-contact-us-section>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-7 col-lg-8 col-xl-9 custom-col-left" [ngClass]="{ 'left-width': isWishlist}">
                    <app-header-search></app-header-search>
                </div>
                <div class="col-4 col-md-5 col-lg-4 col-xl-3 custom-col-right" [ngClass]="{ 'right-width': isWishlist}">
                    <div class="d-flex justify-content-end p-0">
                        <app-header-cart-section *ngIf="showSecondRowHeader"></app-header-cart-section>
                        <app-header-my-garage-section></app-header-my-garage-section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Sticky Header -->
<div class="sticky-header d-none d-md-block" [class.show]="isSticky">
    <div class="sticky-menu" [ngClass]="{ 'sticky-active': isSticky }">
        <app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>
    </div>
    <div class="header-wrapper py-2">
        <div class="row px-3">
            <div class="col-md-12 col-lg-2 text-center text-lg-center logo-tabs  ps-5 d-flex justify-content-center">
                <img  [routerLink]="'/'" (click)="onButtonClick()" *ngIf="showLogo"
                    [src]="cdnImagePath + headerdata?.websiteHeader[firstObj + 2]?.desktop_logo" alt="Logo"
                    class="img-fluid d-none d-md-block desktop-img cursor-pointer" fetchpriority="high" width="170"
                    height="56" />
            </div>
            <div class="col-md-12 col-lg-10">
                <div class="row">
                    <div class="col-12 mt-1 col-md-7 col-lg-8 col-xl-9 mt-3 custom-col-left "
                        [ngClass]="{ 'left-width': isWishlist}">
                        <app-header-search></app-header-search>
                    </div>
                    <div class="col-4 col-md-5 col-lg-4 col-xl-3 mt-3 custom-col-right "
                        [ngClass]="{ 'right-width': isWishlist}">
                        <div class="d-flex justify-content-end p-0">
                            <app-header-cart-section *ngIf="showSecondRowHeader"
                                [showdowntooltip]="showdowntooltip"></app-header-cart-section>
                            <app-header-my-garage-section></app-header-my-garage-section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Header -->
<div class="container d-md-none">
    <app-header-mobile-menu [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"></app-header-mobile-menu>
</div>
<app-shopping-cart *ngIf="showCart"></app-shopping-cart> 